import Api from '@/api'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    data: null,
    loaded: false
  },
  actions: {
    // TODO Synch all calls
    load ({state, commit}, params) {
      commit('setLoaded', false)
      Api.getProjectFields().then(res => {
        commit('setData', res)
        commit('setLoaded', true)
      })
    }
  },
  mutations: {
    setData (state, value) {
      state.data = value
    },
    setLoaded(state, val) {
      state.loaded = val
    },
    resetData (state) {
      state.loaded = false
      state.data = []
    },
  }
}
